// extracted by mini-css-extract-plugin
export default {"Rate":"Rate_Rate__7rKlN","rate":"Rate_rate__-LbFo","plug":"Rate_plug__NIv1F","rateText":"Rate_rateText__NrBwI","phone":"Rate_phone__7g6fI","phoneActive":"Rate_phoneActive__SDLsG"};